import { ComponentProps, forwardRef } from 'react';
import Button from 'antd/es/button';

import './OpButton.scss';

interface OpButtonProps extends ComponentProps<typeof Button> {
  testId?: string;
  gtm?: string;
}

/**
 * OpButton is a wrapper around Ant Design's Button component.
 * It provides a standardized button for the application with consistent styling and behavior.
 * 
 * Use this component for any clickable action triggers like form submissions, navigation, or user interactions.
 * 
 * @example
 * <OpButton type="primary" onClick={handleClick}>
 *   Click Me
 * </OpButton>
 * 
 */
export const OpButton = forwardRef<HTMLButtonElement, OpButtonProps>(
  (
    {
      testId = 'op-button',
      children,
      className = '',
      gtm,
      ...buttonProps
    }: OpButtonProps,
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        data-testid={testId}
        data-gtm={gtm}
        className={`op-button ${className}`.trim()}
        variant="filled"
        {...buttonProps}
      >
        {children}
      </Button>
    );
  },
);
